function GISTemplate () {
    this.user = _.get(Application.instance.getUserData(), 'user')
    this.layers = {}

    this.init()
}

_.assign(GISTemplate.prototype, {
    init: function () {
        var $menuBar = $('#menu-bar')
        this.activateMenu()

        $('.acordion').on('click', '.head', function (e) {
            var $el = $(e.currentTarget)
            var acordionContent = $el.parent().children('.acordion-content')
            if (acordionContent.is(':visible')) {
                $el.removeClass('open')
                acordionContent.hide()
            } else {
                $el.addClass('open')
                acordionContent.show()
            }
        })

        $menuBar.find('.button-open').click(function () {
            if ($menuBar.hasClass('hide')) {
                $menuBar.removeClass('hide')
            }
            else {
                $menuBar.addClass('hide')
                $menuBar.find('li').removeClass('active')
                $menuBar.find('.activ-box').removeClass('close')
            }
        })

        $('.checkbox').click(function () {
            $(this).addClass('checked')
        })

        /* init controls */
        $(".date").datepicker()

        var userData = Application.instance.getUserData()
        switch (userData.user.name) {
            case 'guestMFC':
                this.checkLoadedLayer('MFCLayer')
                break;
            case 'guestAccessible':
                $menuBar.find('.head-item[item="AccessibleEnvironmentLayer"]').trigger('click')
                break;
        }
    },
    activateMenu: function () {
        var self = this
        var $menu = $("#menu-accordion")
        /* accordion menu settings */
        $menu.accordion({
            collapsible: true,
            active: false,
            heightStyle: "content",
            header: "h3",
            beforeActivate: function (e, ui) {
                if (ui.newHeader) {
                    var $input = ui.newHeader.find('input')
                    if (!$input.prop('checked')) {
                        $input.prop('checked', true)
                        self.checkLayer($input)
                    }
                }
            }
        })

        $menu.find('.head-item input').on('change', function () {
            self.checkLayer(this)
            var $head = $(this).closest('.head-item')

            if (this.checked && !$head.hasClass('ui-state.active')) {
                $head.trigger('click')
            } else if (!this.checked && $head.hasClass('ui-state-active')) {
                $head.trigger('click')
            }
        })
        $menu.find('.head-item input, .head-item label').on('click', function (evt) {
            evt.stopPropagation()
        })
    },
    checkLayer: function (caller) {
        var layername = $(caller).attr('id')

        if (!layername) {
            return false
        }

        this.checkLoadedLayer(layername, { hide: true })

        if (!this.layers[ layername ]) {
            return false
        }

        if ($(caller).prop('checked') && !this.layers[ layername ].visible) {
            this.layers[ layername ].show()
        } else {
            if (!$(caller).prop('checked') && this.layers[ layername ].visible) {
                this.layers[ layername ].hide()
            }
        }
    },
    checkLoadedLayer: function (layername, options) {
        options = options || {}

        if (!this.layers[ layername ]) {
            Application.instance.map.showLayer(layername, options)
            if (Application.instance.map.getLayers()[ layername ]) {
                this.layers[ layername ] = Application.instance.map.getLayers()[ layername ].object
            }
        }
    }
})
